import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "./Front/Header";
import Footer from "./Front/Footer";
import API_BASE_URL from "../Config";
import "../styles/global.css";
import "./styles/HealthAwarenessCalendar.css";

const HealthAwarenessCalendar = () => {
  const [awarenessDays, setAwarenessDays] = useState([]);
  const [loading, setLoading] = useState(true);

  const token = localStorage.getItem("authToken");

  useEffect(() => {
    setLoading(true);
    // Public feed: only Active days, served by HealthAwarenessDayController::publicList
    fetch(`${API_BASE_URL}api/awareness-days`, {
      headers: {
        Accept: "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    })
      .then((res) => res.json())
      .then((data) => {
        const list = data && data.status && Array.isArray(data.data) ? data.data : [];
        setAwarenessDays(list);
      })
      .catch(() => setAwarenessDays([]))
      .finally(() => setLoading(false));
  }, [token]);

  return (
    <>
      <Header />
      <main className="health-calendar-page">
      <section className="health-calendar-banner">
        <div className="container">
       

          <div className="health-calendar-banner-content">
            <div className="health-calendar-icon">
              <i className="fa-solid fa-calendar-days"></i>
            </div>

            <div>
              <span className="health-calendar-tag">HEALTH & WELLNESS</span>
              <h1>Health Awareness Calendar 2026</h1>
              <p>
                Stay informed about important health awareness days and
                discover wellness support for every stage of life.
              </p>
            </div>
          </div>
        </div>
      </section>
{/* Breadcrumb */}
      <section className="cl-breadcrumb-bar py-xl-3 py-3">
        <div className="container-fluid">
          <nav aria-label="breadcrumb">
           <ol className="breadcrumb mb-0">
              <li className="breadcrumb-item">
                <Link to="/">
                  <i className="fa-solid fa-house me-1"></i> Home
                </Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Health Awareness Calendar
              </li>
            </ol>
          </nav>
        </div>
      </section>
      <section className="health-calendar-section">
        <div className="container">
          <div className="health-calendar-top">
            <div>
              <span className="health-calendar-subtitle">IMPORTANT DAYS</span>
              <h2>Celebrate Health, Care & Awareness</h2>
              <p>
                Explore important health days that promote prevention,
                education, healthy living, and better well-being.
              </p>
            </div>

            <div className="health-calendar-count">
              <strong>{awarenessDays.length}+</strong>
              <span>Awareness Days</span>
            </div>
          </div>

          {loading ? (
            <div style={{ padding: "48px 20px", textAlign: "center" }}>
              <p>Loading awareness days…</p>
            </div>
          ) : awarenessDays.length === 0 ? (
            <div style={{ padding: "48px 20px", textAlign: "center" }}>
              <p>No awareness days to show right now — check back soon.</p>
            </div>
          ) : (
            <div className="health-calendar-grid">
              {awarenessDays.map((item) => (
                <article
                  className={`health-awareness-card ${item.theme || "green"}`}
                  key={item.id}
                >
                  <div className="health-awareness-card-top">
                    <div className="health-awareness-date">
                      <strong>{item.date}</strong>
                      <span>{item.month}</span>
                    </div>

                    <div className="health-awareness-icon">
                      <i className={item.icon || "fa-solid fa-calendar-days"}></i>
                    </div>
                  </div>

                  <div className="health-awareness-content">
                    <span className="health-awareness-label">
                      Health Awareness Day
                    </span>

                    <h3>{item.title}</h3>

                    {item.medicine && (
                      <div className="health-awareness-medicine">
                        <i className="fa-solid fa-pills"></i>
                        <span>{item.medicine}</span>
                      </div>
                    )}

                    <Link
                      to={ "/contact"}
                      className="health-awareness-link"
                    >
                      Learn More
                      <i className="fa-solid fa-arrow-right"></i>
                    </Link>
                  </div>
                </article>
              ))}
            </div>
          )}
        </div>
      </section>

      <section className="health-calendar-cta">
        <div className="container">
          <div className="health-calendar-cta-box">
            <div>
              <span>YOUR WELLNESS MATTERS</span>
              <h2>Need Personalized Health Guidance?</h2>
              <p>
                Connect with our healthcare team and book your consultation
                today.
              </p>
            </div>

            <Link to="/contact" className="health-calendar-cta-btn">
              Book Appointment
              <i className="fa-solid fa-arrow-right"></i>
            </Link>
          </div>
        </div>
      </section>
      </main>
      <Footer />
    </>
  );
};

export default HealthAwarenessCalendar;